import { Download01 } from "@untitledui/icons";
import { Button } from "@/components/base/buttons/button";

type ExportCsvButtonProps = {
  onClick: () => void;
  isDownloading: boolean;
  disabled?: boolean;
  label?: string;
};

export const ExportCsvButton = ({
  onClick,
  isDownloading,
  disabled = false,
  label = "Export list as CSV",
}: ExportCsvButtonProps) => {
  return (
    <Button
      color="secondary"
      iconLeading={Download01}
      onClick={onClick}
      isDisabled={disabled || isDownloading}
      isLoading={isDownloading}
      showTextWhileLoading
    >
      {isDownloading ? "Exporting CSV..." : label}
    </Button>
  );
};
